import { AttomDataType } from '@alpinehomeair/common';
import { CheckIcon } from '@heroicons/react/20/solid';
import { MapPinIcon } from '@heroicons/react/24/outline';
import { buildPropertySnapshotTasks } from 'utils/property-snapshot';

type PropertySnapshotProps = {
  attomData: AttomDataType;
};

export default function PropertySnapshot({ attomData }: PropertySnapshotProps) {
  const tasks = buildPropertySnapshotTasks(attomData);

  if (tasks.length === 0) {
    return null;
  }

  return (
    <div className='mt-1 rounded-[10px] border border-[#0065B5]/40 bg-[#E5F0F9] px-4 py-3.5'>
      <div className='mb-2.5 flex items-center gap-2'>
        <MapPinIcon className='h-4 w-4 shrink-0 text-[#0065B5]' />
        <p className='text-[0.8125rem] font-bold text-[#0F1720]'>
          Here&apos;s what we found
        </p>
      </div>
      <dl className='grid grid-cols-[repeat(auto-fill,minmax(8.5rem,1fr))] gap-1.5'>
        {tasks.map((task) => (
          <div
            key={task.key}
            className='flex items-center gap-2 rounded-[7px] border border-black/[0.08] bg-white px-2.5 py-1.5'
          >
            <CheckIcon className='h-3.5 w-3.5 shrink-0 text-[#22C55E]' />
            <div className='flex min-w-0 flex-col'>
              <dt className='text-[0.625rem] font-semibold uppercase tracking-wide text-[#4A5568]'>
                {task.label}
              </dt>
              <dd className='whitespace-nowrap text-xs font-bold text-[#0F1720]'>
                {task.value}
              </dd>
            </div>
          </div>
        ))}
      </dl>
      <p className='mt-2.5 text-[0.6875rem] text-[#4A5568]'>
        We&apos;ve used this to prefill your project settings.
      </p>
    </div>
  );
}
